// Pakkevalg ved årsskifte: navn og en kort, varm forklaring.

import type { PackId } from '../sim/types';

export const PACKS: Record<PackId, { name: string; text: string }> = {
  free_air3: { name: '3 luftledninger gratis', text: 'De næste tre luftledninger koster ingenting, uanset længde.' },
  free_double: { name: 'Dobbelt 400 kV', text: 'Én 400 kV-ledning bliver gratis til dobbelt 400 kV. Gælder ikke 150 kV.' },
  big_battery: { name: 'Stort batteri', text: 'Næste batteri er gratis og dobbelt så stærkt.' },
  two_crews: { name: '2 montørhold', text: 'To små grønne varevogne mere.' },
  foreign_plus50: { name: 'Udlandskabel +50 %', text: 'Naboerne kan sende og tage 50 % mere.' },
  flywheel: { name: 'Svinghjul', text: 'Ét svinghjul gratis. Det snurrer og holder takten.' },
  town_meeting: { name: 'Borgermøde', text: 'Kaffe og kringle: al naboprotest forsvinder.' },
  cable_discount: { name: 'Søkabelrabat 30 %', text: 'Søkabler og jordkabler 30 % billigere. Godt til havvind og til at grave ned.' },
  free_station: { name: 'Ny station', text: 'Én station gratis: flere pladser til ledninger, hvor der er trangt.' },
};
